import { FC } from 'react'
import clsx from 'clsx'
import PdMedia from '@/components/pd-media/pd-media'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import { useGSAP } from '@gsap/react'
import TitleAndDesc from '@/components/standard/title-and-desc'
import useScrollScale from '@/hooks/tools/use-scroll-scale'

gsap.registerPlugin(ScrollTrigger, useGSAP)

type Section14Type = {
  title: string
  desc: string
  mediaUrl: string
  tagGroup: Array<{
    title: string
    desc: string
  }>
  theme?: string
}
const Section14: FC<Section14Type> = ({ theme, mediaUrl, tagGroup, title, desc }) => {
  return (
    <div className={clsx('w-full h-fit', 'py-15 laptop:py-30', `pd-theme-${theme}`, 'bg-anti-blk')}>
      <TitleAndDesc title={title} desc={desc} titleTag="h2" />
      <div className={clsx('w-full mx-auto flex flex-col gap-8', 'laptop:w-300 laptop:gap-16', 'px-6 laptop:px-0')}>
        <div className={clsx('flex flex-col gap-5', 'laptop:gap-12', 'laptop:flex-row')}>
          <div
            className={clsx('flex-none laptop:w-588px overflow-hidden', 'h-358px laptop:h-fit')}
            style={{ aspectRatio: '1/1' }}
          >
            <PdMedia src={mediaUrl} mask={false} />
          </div>
          <div className={clsx('flex-1', 'flex flex-col gap-5', 'laptop:gap-12 laptop:justify-center')}>
            {tagGroup?.map((item) => (
              <div key={item?.title}>
                {/* title */}
                <div className={clsx('mb-1')}>
                  <h3
                    className={clsx('font-semibold whitespace-pre-wrap', 'text-16 laptop:text-20', 'text-fc-primary')}
                  >
                    {item?.title}
                  </h3>
                </div>
                {/* desc */}
                <p className={clsx('text-14 whitespace-pre-wrap', 'text-14 laptop:text-18', 'text-fc-secondary')}>
                  {item?.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Section14
